const Paths = {
  Default: "/",
  Home: "/",
  Error: "/error",
  NotFound: "/not-found",
  Forbidden: "/forbidden",
  User: "/people/:userId",
  UserMap: "/people/:userId/map",
  UserSettings: "/settings",
  Role: "/roles/:roleGuid",
  Team: "/teams/:slug",
  TeamIssues: "/teams/:slug/issues",
  TeamStrategicMap: "/teams/:slug/strategic-map",
  TeamPlanEdit: "/teams/:slug/plan/v/:planVersionId/edit",
  TeamMetrics: "/teams/:slug/metrics",
  TeamResources: "/teams/:slug/resources",
  TeamSettings: "/teams/:slug/settings",
  ActionItemDetails: "action-items/:actionItemGuid",
  IssueDetails: "issues/:issueGuid",
  PlanPurposeDetails: "/teams/:slug/plan/purpose",
  PlanValueDetails: "/teams/:slug/plan/values/:planValueGuid",
  PlanMissionDetails: "/teams/:slug/plan/mission",
  MilestoneDetails: "/teams/:slug/plan/milestones/:milestoneGuid",
  GoalDetails: "/teams/:slug/plan/goals/:goalGuid",
  StrategyDetails: "/teams/:slug/plan/areas-of-focus/:strategyGuid",
  KeyInitiativeDetails: "/teams/:slug/plan/priorities/:keyInitiativeGuid",
  MetricDetails: "/metrics/:metricGuid",
  SignOut: "/sign-out",
  Search: "/search",
  Chat: "/chat",
  Reports: "/reports",
  OrganizationReport: "/reports/organization-report",
  CoherenceReport: "/reports/coherence-report",
  Surveys: "/surveys",
  Survey: "/surveys/:guid",
  SurveyResponses: "/surveys/:guid/responses",
  SurveyActions: "/surveys/:guid/actions",
  SurveyResponse: "/surveys/:guid/response",
};

export { Paths };
